import { Config } from "@/shared/config";
import { orderDuplicateCard } from "../api/cardService";
import { CardEmployerPrinSettingsRequest } from "@/admin/types";

const cardServiceUri = Config.CardServicebaseUri;

export default {
  get cardV1 () {
    return `${cardServiceUri}/card/v1`;
  },
  get cardV2 () {
    return `${cardServiceUri}/card/v2`;
  },
  fiservDebitCards () {
    return `${this.cardV1}/list`;
  },
  debitCards () {
    return `${this.cardV2}/list`;
  },
  setDebitCardPin (cardId: number): string {
    return `${this.cardV1}/pin/${cardId}`;
  },
  orderPrimaryCard (): string {
    return `${this.cardV1}/primary-card`;
  },
  orderPrimaryDuplicateCard (): string {
    return `${this.cardV1}/plastic/primary/duplicate`;
  },
  orderDuplicateCard (cardId: number): string {
    return `${this.cardV1}/duplicate-plastic/${cardId}`;
  },
  orderReplacementCard (cardId: number): string {
    return `${this.cardV2}/replace/${cardId}`;
  },
  deativateFiservDebitCard (fiservUserInfoId: number): string {
    return `${this.cardV1}/cancel/${fiservUserInfoId}`;
  },
  replaceFiservDebitCard (fiservUserInfoId: number): string {
    return `${this.cardV1}/replace/${fiservUserInfoId}`;
  },
  confirmReplacementFiservDebitCard (fiservUserInfoId: number): string {
    return `${this.cardV1}/confirm-replacement/${fiservUserInfoId}`;
  },
  addFiservDebitCardDependent (): string {
    return `${this.cardV1}/dependent/`;
  },
  partnerCardIssueCriterias (partnerId: number): string {
    return `${this.cardV1}/issue-criterias/partner/${partnerId}`;
  },
  employerCardIssueCriteria (employerId: number): string {
    return `${this.cardV1}/issue-criterias/employer/${employerId}`;
  },
  accountHoldersIssueCardCriterias (employerId: number): string {
    return `${this.cardV1}/issue-criterias/employer/${employerId}/account-holder`;
  },
  issueCardCustomization (issueCardCriteriaId: number): string {
    return `${this.cardV1}/issue-criterias/${issueCardCriteriaId}/customization`;
  },
  deleteCardIssueCriterias (id: number): string {
    return `${this.cardV1}/issue-criterias/${id}`;
  },
  createCardIssueCriteria (): string {
    return `${this.cardV1}/issue-criterias`;
  },
  activateCardIssueCriterias (id: number): string {
    return `${this.cardV1}/issue-criterias/${id}`;
  },
  setCardCriteriaCustomization (issueCardCriteriaId: number) {
    return `${this.cardV1}/issue-criterias/${issueCardCriteriaId}/customization`;
  },
  cardCustomizationBulkImportFiles () {
    return `${this.cardV1}/issue-criterias/bulk-import-files`;
  },
  cardCustomizationBulkImportResultsFileUrl (fileId: number) {
    return `${this.cardV1}/issue-criterias/bulk-import-files/${fileId}/results`;
  },
  getEmployersForPartner (partnerId: number): string {
    return `${this.cardV1}/partners/${partnerId}/employers`;
  },
  getUnconfiguredEmployers (partnerId: number): string {
    return `${this.cardV1}/partners/${partnerId}/unconfigured-employers/`;
  },
  partnerIndependentCardManagement (partnerId: number): string {
    return `${this.cardV1}/partners/${partnerId}/independent-card-management`;
  },
  dismissPendingDependentFiservDebitCard (fiservAuthorizedSignerPendingId: number) {
    return `${this.cardV1}/dependent/dismiss-pending/${fiservAuthorizedSignerPendingId}`;
  },
  getWexCardList () {
    return `${this.cardV1}/wex/card-list`;
  },
  getCardProviderOptions () {
    return `${this.cardV1}/provider-options`;
  },
  getUserCapabilities () {
    return `${this.cardV1}/user/capabilities`;
  },
  cardIssueCustomizationOptions () {
    return `${this.cardV1}/issue-criterias/customize/options`;
  },
  feePackages () {
    return `${this.cardV1}/fee-packages`;
  },
  setCardEmployerPrinSettings () {
    return `${this.cardV1}/employer-prin-settings`;
  },
  getCardEmployerPrinSettings (employerId: number): string {
    return `${this.cardV1}/employer-prin-settings/${employerId}`;
  },
  purseStackingOrdersList () {
    return `${this.cardV1}/purse-stacking-orders`;
  },
  fiservCodeMappings () {
    return `${this.cardV1}/fiserv-code-mappings`;
  },
  fiservCodeMapping (fiservCodeMappingId: number) {
    return `${this.cardV1}/fiserv-code-mappings/${fiservCodeMappingId}`;
  }
};
